import { render, staticRenderFns } from "./MotoBombaComandoForm.vue?vue&type=template&id=24b68d9a&"
import script from "./MotoBombaComandoForm.vue?vue&type=script&lang=js&"
export * from "./MotoBombaComandoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports